import { checkForTyreDimensionGETParams } from '../check_for_tyre_dimension_get_params';
import { checkForFullDimensionInUrl } from '../check_for_full_dimension_in_url';
import { someTrue } from '../../../_modules/helper/some_true';

export const checkIfTextShouldBeFolded = () => someTrue([
    checkForTyreDimensionGETParams(),
    checkForFullDimensionInUrl(),
]);
